import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/buttons/arrow-diag.svg'
import _imports_1 from '@assets/img/Rolling-loading.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-a7548d62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "payment_acquiring_to_card",
  class: "payment_account_number tab-pane"
}
const _hoisted_2 = {
  action: "",
  class: "form_paym_account_number form_box",
  role: "form",
  "data-lng": "ru"
}
const _hoisted_3 = { class: "recipient-detale" }
const _hoisted_4 = { class: "field form-group" }
const _hoisted_5 = { for: "ac_iban" }
const _hoisted_6 = { class: "field form-group" }
const _hoisted_7 = { for: "ac_sum" }
const _hoisted_8 = { class: "field form-group" }
const _hoisted_9 = { for: "ac_payment_purpose" }
const _hoisted_10 = {
  key: 0,
  class: "field form-group",
  style: { marginTop: '15px', marginBottom: '0' }
}
const _hoisted_11 = { for: "ac_sample_name" }
const _hoisted_12 = { class: "additional_field" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "btn_box" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "loader"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_toggler = _resolveComponent("ui-toggler")!
  const _component_ui_message_error = _resolveComponent("ui-message-error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$localization.getTranslate("Receipient Detale")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$localization.getTranslate("CardNumber")), 1),
        _createVNode(_component_ui_input, {
          modelValue: _ctx.Form.ToCardNumber,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Form.ToCardNumber) = $event)),
          iconName: "world-sphere-icon",
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$localization.getTranslate("Amount")), 1),
        _createVNode(_component_ui_input, {
          modelValue: _ctx.Form.Amount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Form.Amount) = $event)),
          type: "number",
          currency: "EUR",
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$localization.getTranslate("PurposePayment")), 1),
        _createVNode(_component_ui_input, {
          modelValue: _ctx.Form.Description,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Form.Description) = $event))
        }, null, 8, ["modelValue"])
      ]),
      (_ctx.IsSave)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$localization.getTranslate("SampleName")), 1),
            _createVNode(_component_ui_input, {
              modelValue: _ctx.Form.TemplateName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Form.TemplateName) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_ui_toggler, {
          modelValue: _ctx.IsConfirmCondition,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.IsConfirmCondition) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", {
          for: "conditions-checkbox",
          innerHTML: _ctx.$localization.getTranslate('ConfirmConditionText')
        }, null, 8, _hoisted_13)
      ]),
      _createVNode(_component_ui_message_error, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.ErrorMessage), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "ui_continue_button",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.InitTransfer && _ctx.InitTransfer(...args)))
        }, [
          _hoisted_15,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Send money")), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([{ active: _ctx.IsLoad }, "loader-gif"])
        }, _hoisted_17, 2)
      ])
    ])
  ]))
}